import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import Login from './pages/Login';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import AiDisclosure from './pages/AiDisclosure';
import CustomerPortal from './pages/customer/CustomerPortal';

// Dev mode bypass — lets us preview the portal without live Azure auth
const DEV_MODE = import.meta.env.VITE_DEV_MODE === 'true';

function AuthenticatedApp() {
  // Show customer portal to all authenticated users
  return (
    <Routes>
      <Route path="/customer/*" element={<CustomerPortal />} />
      <Route path="*" element={<Navigate to="/customer/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  const { inProgress } = useMsal();
  useIsAuthenticated();

  if (DEV_MODE) {
    return (
      <BrowserRouter>
        <AuthenticatedApp />
      </BrowserRouter>
    );
  }

  if (inProgress !== InteractionStatus.None) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <p>Signing in...</p>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <AuthenticatedTemplate>
        <AuthenticatedApp />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Routes>
          <Route path="/auth/callback" element={<Navigate to="/" replace />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/ai-disclosure" element={<AiDisclosure />} />
          <Route path="*" element={<Login />} />
        </Routes>
      </UnauthenticatedTemplate>
    </BrowserRouter>
  );
}

export default App;
